import { Injectable, Type, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
@Injectable()
export class ModalService {
	public loadedComponent: ComponentRef<any> | null = null;
	public canBeClosed = true;
	private viewContainerRef: ViewContainerRef | null = null;

	constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

	/**
	 * Adds an component reference to be rendered within a modal
	 *
	 * @param component An Angular component
	 */
	public attach<T>(component: Type<T>, closable: boolean = true): ComponentRef<T> {
		if (this.loadedComponent) {
			throw new Error('Another component already loaded');
		}

		const factory = this.componentFactoryResolver.resolveComponentFactory(component);
		this.loadedComponent = this.viewContainerRef.createComponent<T>(factory);
		this.canBeClosed = closable;

		return this.loadedComponent;
	}

	/**
	 * Removes current component reference
	 */
	public detach(): void {
		if (this.loadedComponent === null) return;

		this.loadedComponent.destroy();
		this.loadedComponent = null;
	}

	/**
	 * Set viewcontainer where modals will be loaded
	 */
	public setViewContainerRef(viewContainerRef: ViewContainerRef) {
		this.viewContainerRef = viewContainerRef;
	}
}
